/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';

import {
    HIDE_ANTIBURN_OSD,
    SET_PARENTAL_CHECK_ON_ANTIBURN_OSD,
    SHOW_ANTIBURN_OSD,
    UPDATE_ANTIBURN_TIMER,
} from './antiburnosd.types';

export const showAntiburnOsdAction = (): AnyAction => ({
    type: SHOW_ANTIBURN_OSD,
    payload: {
        isActive: true,
    },
});

export const hideAntiburnOsdAction = (): AnyAction => ({
    type: HIDE_ANTIBURN_OSD,
    payload: {
        isActive: false,
    },
});

export const resetAntiburnTimeoutAction = (antiburnTimer: any): AnyAction => ({
    type: UPDATE_ANTIBURN_TIMER,
    payload: {
        antiburnTimer,
    },
});

export const setParentalCheckOnAntiburnOsdAction = (shouldDoParentalCheck: boolean): AnyAction => ({
    type: SET_PARENTAL_CHECK_ON_ANTIBURN_OSD,
    payload: {
        shouldDoParentalCheck,
    },
});
